(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-burnouts-entrance]').forEach(entrance => {
      if (entrance.dataset.initialized) return;
      entrance.dataset.initialized = 'true';
      entrance.querySelectorAll('[data-bay]').forEach(bay => {
        const toggle = bay.querySelector('[data-door-toggle]');
        const label = toggle.getAttribute('aria-label').replace(/^Open the /, '').replace(/ door$/, '');
        let pinned = false;
        let hovering = false;
        const update = () => {
          const open = pinned || hovering || bay.contains(document.activeElement) && document.activeElement !== toggle;
          bay.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', String(open));
          toggle.setAttribute('aria-label', `${open ? 'Close' : 'Open'} the ${label} door`);
        };
        bay.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && matchMedia('(hover:hover)').matches) { hovering = true; update(); } });
        bay.addEventListener('pointerleave', () => { hovering = false; update(); });
        toggle.addEventListener('click', () => { pinned = !pinned; update(); });
        bay.addEventListener('focusin', update);
        bay.addEventListener('focusout', () => requestAnimationFrame(update));
        bay.addEventListener('keydown', e => { if (e.key === 'Escape') { pinned = false; hovering = false; toggle.focus(); update(); } });
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', e => initialize(e.target));
})();
